export const pageSettingsReducer = (state = {}) => state;
